/* ck-global.js - Milie Organics global JS overrides */

/* Dr Free Gift / BOGO: app renders the gift image at _100x (blurry at 200px).
   Swap to _200x for a crisp display. Modal is injected dynamically, so observe. */
(function () {
  function upsizeGiftImages() {
    document
      .querySelectorAll('#docapp-gift-choice-modal-wrapper .docapp-gift-choice-modal-item-wrapper img')
      .forEach(function (img) {
        var src = img.getAttribute('src') || '';
        var next = src.replace(/_100x(\.[a-z0-9]+)/i, '_200x$1');
        if (next !== src) img.setAttribute('src', next);
      });
  }
  if (document.readyState !== 'loading') upsizeGiftImages();
  else document.addEventListener('DOMContentLoaded', upsizeGiftImages);
  new MutationObserver(upsizeGiftImages).observe(document.documentElement, { childList: true, subtree: true });
})();
